import territoryProductType from "./territory-product-type"

export default [
    {
        code: '1',
        name: 'Territory 1'
    },
    {
        code: '2',
        name: 'Territory 2'
    },
    {
        code: '3',
        name: 'Territory 3'
    },
    {
        code: '4',
        name: 'Territory 4'
    }
]

export const getMarketOptions = (territoryData, type='type') => {
    switch (territoryData[type]) {
        case territoryProductType[0].code: return [
            { code: "DFW", name: "Texas - DFW" },
            { code: "Houston", name: "Texas - Houston" }
        ]
        case territoryProductType[1].code: return [
            { code: "Arkansas", name: "Arkansas" },
            { code: "California - Central", name: "California - Central" },
            { code: "California - Northern", name: "California - Northern" },
            { code: "California - Southern", name: "California - Southern" },
            { code: "Louisiana", name: "Louisiana" },
            { code: "Oklahoma", name: "Oklahoma" },
            { code: "Central Texas", name: "Texas - Central" },
            { code: "DFW", name: "Texas - DFW" },
            { code: "East Texas", name: "Texas - East" },
            { code: "Houston", name: "Texas - Houston" }
        ]
        case territoryProductType[2].code: return [
            { code: "DFW", name: "Texas - DFW" },
            { code: "Houston", name: "Texas - Houston" }
        ]
        case territoryProductType[3].code: return [
            { code: "DFW", name: "Texas - DFW" },  
            { code: "Houston", name: "Texas - Houston" }
        ]
        case territoryProductType[4].code: return [
            { code: "California - Central", name: "California - Central" },
            { code: "California - Northern", name: "California - Northern" },
            { code: "California - Southern", name: "California - Southern" },
            { code: "DFW", name: "Texas - DFW" },
            { code: "Houston", name: "Texas - Houston" }
        ]
    }
}

export const getTerritoriesOptions = (territoryData, type='type', market='market') => {
    switch (territoryData[type] + territoryData[market]) {
        case territoryProductType[1].code + "Arkansas": return [ 
            {
                code: '1',
                name: 'Arkansas'
            }
        ];
        case territoryProductType[1].code + "California - Central": return [ 
            {
                code: '1',
                name: 'California - Central'
            }
        ];
        case territoryProductType[4].code + "California - Central": return [ 
            {
                code: '1',
                name: 'California - Central'
            }
        ];
        case territoryProductType[1].code + "California - Northern": return [ 
            {
                code: '1',
                name: 'California - Northern'
            }
        ];
        case territoryProductType[4].code + "California - Northern": return [ 
            {
                code: '1',
                name: 'California - Northern'
            }
        ];
        case territoryProductType[1].code + "California - Southern": return [ 
            {
                code: '1',
                name: 'Orange County & Inland Empire'
            }
        ];
        case territoryProductType[4].code + "California - Southern": return [ 
            {
                code: '1',
                name: 'Orange County & Inland Empire'
            }
        ];
        case territoryProductType[0].code + "DFW": return [ 
            {
                code: '2',
                name: 'Dallas North'
            },
            {
                code: '3',
                name: 'Dallas South'
            },
            {
                code: '1',
                name: 'Fort Worth North'
            },
            {
                code: '4',
                name: 'Fort Worth South'
            }
        ];
        case territoryProductType[1].code + "DFW": return [ 
            {
                code: '3',
                name: 'Dallas MSA'
            },
            {
                code: '2',
                name: 'Fort Worth MSA'
            },
            {
                code: '1',
                name: 'North DFW'
            }
        ];
        case territoryProductType[2].code + "DFW": return [
            {
                code: '1',
                name: 'Fort Worth'
            },
            {
                code: '2',
                name: 'North Dallas'
            },
            {
                code: '3',
                name: 'South Dallas'
            }
        ];
        case territoryProductType[2].code + "Houston": return [
            {
                code: '1',
                name: 'Northeast Houston'
            },
            {
                code: '2',
                name: 'Southwest Houston'
            }
        ];
        case territoryProductType[3].code + "DFW": return [
            {
                code: '2',
                name: 'Northeast DFW'
            },
            {
                code: '1',
                name: 'Northwest DFW'
            },
            {
                code: '3',
                name: 'Southeast DFW'
            },
            {
                code: '4',
                name: 'Southwest DFW'
            }
        ];
        case territoryProductType[4].code + "DFW": return [
            {
                code: '1',
                name: 'Collin/Denton County'
            },
            {
                code: '3',
                name: 'Dallas/Rockwall County'
            },
            {
                code: '2',
                name: 'Tarrant/Johnson/Hood County'
            }
        ];
        case territoryProductType[1].code + "East Texas": return [ 
            {
                code: '1',
                name: 'Texas - East'
            }
        ];
        case territoryProductType[0].code + "Houston": return [ 
            {
                code: '2',
                name: 'Northeast Houston'
            },
            {
                code: '1',
                name: 'Northwest Houston'
            },
            {
                code: '3',
                name: 'Southeast Houston'
            },
            {
                code: '4',
                name: 'Southwest Houston'
            }
        ];
        case territoryProductType[1].code + "Houston": return [ 
            {
                code: '2',
                name: 'Northeast Houston'
            },
            {
                code: '1',
                name: 'Northwest Houston'
            },
            {
                code: '3',
                name: 'Southeast Houston'
            },
            {
                code: '4',
                name: 'Southwest Houston'
            }
        ];
        case territoryProductType[3].code + "Houston": return [
            {
                code: '1',
                name: 'Northeast Houston'
            },
            {
                code: '3',
                name: 'Northwest Houston'
            },
            {
                code: '2',
                name: 'South Houston'
            }
        ];
        case territoryProductType[4].code + "Houston": return [
            {
                code: '2',
                name: 'East Houston'
            },
            {
                code: '1',
                name: 'Northwest Houston'
            },
            {
                code: '3',
                name: 'Southwest Houston'
            }
        ];
        case territoryProductType[1].code + "Louisiana": return [ 
            {
                code: '1',
                name: 'Louisiana'
            }
        ];
        case territoryProductType[1].code + "Oklahoma": return [ 
            {
                code: '1',
                name: 'Oklahoma'
            }
        ];
    }
}

export const flattenedTerritories  = [
    { code: "Arkansas 1", name: "Arkansas" },
    { code: "California - Central 1", name: "California - Central" },
    { code: "California - Northern 1", name: "California - Northern" },
    { code: "DFW 2", name: "Dallas North" },
    { code: "DFW 3", name: "Dallas South" },
    { code: "DFW 1", name: "Fort Worth North" },
    { code: "Houston 2", name: "Northeast Houston" },
    { code: "Houston 1", name: "Northwest Houston" },
    { code: "California - Southern 1", name: "Orange County & Inland Empire" },
    { code: "Louisiana 1", name: "Louisiana" },
    { code: "Oklahoma 1", name: "Oklahoma" },
    { code: "Houston 3", name: "Southeast Houston" },
    { code: "DFW 4", name: "Southwest DFW" },
    { code: "Houston 4", name: "Southwest Houston" },
    { code: "East Texas 1", name: "Texas - East" }
  ];


 export const flattenedTerritoriesCombinations = [
    { code: "MT Retail Arkansas 1", name: "Arkansas" },
    { code: "MT Retail California - Central 1", name: "California - Central" },
    { code: "STNL Retail California - Central 1", name: "California - Central" },
    { code: "MT Retail California - Northern 1", name: "California - Northern" },
    { code: "STNL Retail California - Northern 1", name: "California - Northern" },
    { code: "MT Retail California - Southern 1", name: "Orange County & Inland Empire" },
    { code: "STNL Retail California - Southern 1", name: "Orange County & Inland Empire" },

    { code: "Industrial DFW 2", name: "Dallas North" },
    { code: "Industrial DFW 3", name: "Dallas South" },
    { code: "Industrial DFW 1", name: "Fort Worth North" },
    { code: "Industrial DFW 4", name: "Fort Worth South" },

    { code: "MT Retail DFW 3", name: "Dallas MSA" },
    { code: "MT Retail DFW 2", name: "Fort Worth MSA" },
    { code: "MT Retail DFW 1", name: "North DFW" },

    { code: "Multi-Family DFW 1", name: "Fort Worth" },
    { code: "Multi-Family DFW 2", name: "North Dallas" },
    { code: "Multi-Family DFW 3", name: "South Dallas" },

    { code: "Office DFW 2", name: "Northeast DFW" },
    { code: "Office DFW 1", name: "Northwest DFW" },
    { code: "Office DFW 3", name: "Southeast DFW" },
    { code: "Office DFW ", name: "Southwest DFW" },

    { code: "STNL Retail DFW 1", name: "Collin/Denton County" },
    { code: "STNL Retail DFW 3", name: "Dallas/Rockwall County" },
    { code: "STNL Retail DFW 2", name: "Tarrant/Johnson/Hood County" },

    { code: "MT Retail East Texas 1", name: "Texas - East" },

    { code: "Industrial Houston 2", name: "Northeast Houston" },
    { code: "Industrial Houston 1", name: "Northwest Houston" },
    { code: "Industrial Houston 3", name: "Southeast Houston" },
    { code: "Industrial Houston 4", name: "Southwest Houston" },

    { code: "MT Retail Houston 2", name: "Northeast Houston" },
    { code: "MT Retail Houston 1", name: "Northwest Houston" },
    { code: "MT Retail Houston 3", name: "Southeast Houston" },
    { code: "MT Retail Houston 4", name: "Southwest Houston" },

    { code: "Office Houston 1", name: "Northeast Houston" },
    { code: "Office Houston 3", name: "Northwest Houston" },
    { code: "Office Houston 2", name: "South Houston" },

    { code: "STNL Retail Houston 2", name: "East Houston" },
    { code: "STNL Retail Houston 1", name: "Northwest Houston" },
    { code: "STNL Retail Houston 3", name: "Southwest Houston" },

    { code: "MT Retail Louisiana 1", name: "Louisiana" },
    { code: "MT Retail Oklahoma 1", name: "Oklahoma" }
];

  export const marketOptionsCombinations = [
    // Industrial
    { code: "DFW#Industrial", name: "Texas - DFW" },
    { code: "Houston#Industrial", name: "Texas - Houston" },
  
    // MT Retail
    { code: "Arkansas#MT Retail", name: "Arkansas" },
    { code: "California - Central#MT Retail", name: "California - Central" },
    { code: "California - Northern#MT Retail", name: "California - Northern" },
    { code: "California - Southern#MT Retail", name: "California - Southern" },
    { code: "Louisiana#MT Retail", name: "Louisiana" },
    { code: "Oklahoma#MT Retail", name: "Oklahoma" },
    { code: "Central Texas#MT Retail", name: "Texas - Central" },
    { code: "DFW#MT Retail", name: "Texas - DFW" },
    { code: "East Texas#MT Retail", name: "Texas - East" },
    { code: "Houston#MT Retail", name: "Texas - Houston" },
  
    // Multi-Family
    { code: "DFW#Multi-Family", name: "Texas - DFW" },
  
    // Office
    { code: "DFW#Office", name: "Texas - DFW" },
    { code: "Houston#Office", name: "Texas - Houston" },
  
    // STNL Retail
    { code: "California - Central#STNL Retail", name: "California - Central" },
    { code: "California - Northern#STNL Retail", name: "California - Northern" },
    { code: "California - Southern#STNL Retail", name: "California - Southern" },
    { code: "DFW#STNL Retail", name: "Texas - DFW" },
    { code: "Houston#STNL Retail", name: "Texas - Houston" }
  ];

  export const getMarketOptionsCombinations = (
    territoryData,
    type = 'type',
    market = 'market'
) => {

    // Convert comma-separated values to trimmed arrays
    const typeValues = (territoryData[type] || '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);

    // Filter where option.code matches any combination
    const filtered = marketOptionsCombinations.filter(option =>
        typeValues.some(combo => option.code.includes(combo))
    );

    // Remove duplicates by name, keeping only the first occurrence
    const uniqueByName = Array.from(
        new Map(filtered.map(item => [item.name, item])).values()
    );

    return uniqueByName;
};

export const getTerritoriesOptionsCombinations = (
    territoryData,
    type = 'type',
    market = 'market',
    territory = 'territory'
) => {

    const typeValues = (territoryData[type] || '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);

    const marketValues = (territoryData[market] || '')
        .split(',')
        .map(s => s.trim().split('#')[0])
        .filter(Boolean);


    // Create all combinations of market + type + territory
    const combinations = marketValues.flatMap(marketVal =>
        typeValues.map(typeVal =>`${typeVal} ${marketVal}`
        )
    );

    // Filter options where code matches the full combination
    return flattenedTerritoriesCombinations.filter(option =>
        combinations.some(combo => option.code.includes(combo))
    );
};
